import script from "./SimpleHistoriesPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleHistoriesPanel.vue?vue&type=script&setup=true&lang=ts"

import "./SimpleHistoriesPanel.vue?vue&type=style&index=0&id=343c725a&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-343c725a"]])

export default __exports__